export default "__VITE_ASSET__D5OTRJUq__"